import React, {
  FC, useContext,
} from 'react';
import IProjectContact from '../../../util-api/models/projectContact';

import useQueryBillingSettings from '../../../util-api/useQueryBillingSettings';

import useQueryContact from '../../../util-api/useQueryContact';
import useQueryProjectVitals from '../../../util-api/useQueryProjectVitals';

import FilevineIcon from '../../FilevineIcon';
import ProjectContext from '../../ProjectContext';
import BillingTimer from '../BillingTimer';
import CollapsibleSection from '../CollapsibleSection';
import ContactPreview from '../ContactPreview';
import GenericCard from '../GenericCard';
import Persona from '../Persona';
import Vitals from '../Vitals';

const css = require('./ProjectHeader.module.scss');

const ProjectHeader: FC = () => {
  const { currentProjectId, currentProjectData } = useContext(ProjectContext);

  // Get org billing settings
  const {
    data: billingSettings,
    isLoading: billingLoading,
    error: billingError,
  } = useQueryBillingSettings();

  // Get vitals data when project changes
  const { data: vitals = [] } = useQueryProjectVitals(currentProjectId || null);

  const contactId = currentProjectData?.clientId?.native;

  // Get client data when project changes
  const {
    contact,
    error: clientError,
    loading: clientLoading,
    refetchContact,
  } = useQueryContact(contactId || '');

  return (
    <>
      <div className={css.projectHeader}>
        <div className={css.projectHeaderContact}>
          {clientLoading && <div className={css.projectContactLoading}><Persona loading small /></div>}
          {contact
            && contact.personId
            && !clientError
            && (
            <ContactPreview
              projectContact={
                {
                  orgContact: contact, role: 'Client', orgContactId: {}, projectContactId: {},
                } as IProjectContact
              }
              clickable
              onRefresh={() => refetchContact()}
            />
          )}
        </div>
      {currentProjectId
        && billingSettings
        && !billingError
        && !billingLoading
        && billingSettings?.isBillingEnabled
        && (
        <GenericCard
          outlined={false}
          buttonText=" Billing"
          buttonIcon={<FilevineIcon icon="clock-o" />}
          child={(
            <BillingTimer
              projectId={currentProjectId}
              isDraftEnabled={billingSettings?.saveAsDraftEnabled}
              isDraftDefault={billingSettings?.saveAsDraftDefault}
            />
          )}
          genCardButtonClass={css.billingButton}
        />
        )}
      </div>
      <CollapsibleSection
        collapsed
        title="Vitals"
        icon="heartbeat"
        content={(
          <Vitals
            vitals={vitals}
            phaseName={currentProjectData ? currentProjectData.phaseName : undefined}
          />
        )}
      />
    </>
  );
};

export default ProjectHeader;
